module.exports = "https://www.gc-pro.gnp.com.mx/4858275ef556149489941658814b08c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/group_19.svg
// module id = 8112
// module chunks = 0